import { render, staticRenderFns } from "./PackageLabel.vue?vue&type=template&id=3d64702f&scoped=true"
import script from "./PackageLabel.vue?vue&type=script&lang=js"
export * from "./PackageLabel.vue?vue&type=script&lang=js"
import style0 from "./PackageLabel.vue?vue&type=style&index=0&id=3d64702f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64702f",
  null
  
)

export default component.exports